import React from 'react';
import {move_design_to_folder} from "../../Dashboard/actions";
import {toastr} from "react-redux-toastr";
import {Col, Modal, Row} from "react-bootstrap";

export const MoveToFolderModal = ({show, onHide, folders, activeDesign, omitFolders, refreshFolders}) => (
    <Modal show={show}
           onHide={onHide}>
        <Modal.Header closeButton>
            <Modal.Title>Move design to folder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <Col xs={12}>
                    {
                        (folders && folders.length > 0) ? folders
                            .filter(element => element.role === 'edit')
                            .filter(element => element['folder']['type'] === 'design')
                            .filter(element => !omitFolders.includes(element['folder']['_id']))
                            .map((element, idx) => {
                                    return (
                                        <Col xs={6}>
                                            <div key={'move-to-folder-btn' + idx}
                                                 className="folder_icon"
                                                 style={{
                                                     'width': '250px',
                                                     'height': '72px',
                                                     'cursor': 'pointer',
                                                     'padding': '10px'
                                                 }}
                                                 onClick={() => {
                                                     move_design_to_folder(element.folder._id, activeDesign)
                                                         .then(() => {
                                                             if (refreshFolders) {
                                                                 refreshFolders();
                                                             }
                                                         })
                                                         .then(() => onHide())
                                                         .then(() => toastr.success("Moved design to folder"))
                                                         .catch(() => toastr.error("Something went wrong :/"))
                                                 }}
                                            >
                                                <img style={{'paddingRight': '10px'}}
                                                     src="https://img.icons8.com/cotton/64/000000/folder-invoices--v1.png"/><span
                                                style={{
                                                    'fontSize': '1.5rem',
                                                    'fontWeight': '500'
                                                }}>{element.folder.name}</span>
                                            </div>
                                        </Col>
                                    )
                                }
                            ): <div/>
                    }
                </Col>
            </Row>
        </Modal.Body>
    </Modal>
);